if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.swiperInstance = null;

        // Prevent Swiper area clicks from closing the modal
        this.addEventListener(
          'pointerup',
          (event) => {
            if (event.pointerType === 'mouse' && event.target.closest('.product-modal-swiper')) {
              event.stopImmediatePropagation();
            }
          },
          true
        );
      }

      hide() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initSwiper();
      }

      initSwiper() {
        const swiperEl = this.querySelector('.product-modal-swiper');
        if (!swiperEl) {
          this.showActiveMedia();
          return;
        }

        const mediaId = this.openedBy.getAttribute('data-media-id');
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        let initialSlide = 0;

        slides.forEach((slide, index) => {
          if (slide.dataset.slideMediaId === mediaId) {
            initialSlide = index;
          }
        });

        this.swiperInstance = new Swiper(swiperEl, {
          direction: 'horizontal',
          loop: false,
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 0,
          speed: 300,
          initialSlide: initialSlide,
          simulateTouch: false,
          allowTouchMove: false,
          grabCursor: false,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
          },
        });

        // Load deferred media on slide change
        this.swiperInstance.on('slideChange', () => {
          window.pauseAllMedia();
          const activeSlide = slides[this.swiperInstance.activeIndex];
          this.loadSlideMedia(activeSlide);
        });

        // Load deferred media for initial slide
        this.loadSlideMedia(slides[initialSlide]);
      }

      loadSlideMedia(slide) {
        if (!slide) return;
        const deferredMedia = slide.querySelector('deferred-media');
        if (!deferredMedia) return;
        const template = deferredMedia.querySelector('template');
        const content = template ? template.content : null;
        if (content && content.querySelector('.js-youtube')) {
          deferredMedia.loadContent();
        }
      }

      // Fallback for non-Swiper modal markup
      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
